export default "__VITE_ASSET__CM0AMaRh__"